<template>
  <div id="marketing_email_analytics" class="flex flex-col gap-2">
    <EmailAnalyticsGrid />
    <EmailEngagementActivity :type="analyticTypes.TABLE" />
    <EmailEngagementActivity :type="analyticTypes.CHART" />
    <EmailFunnel />
  </div>
</template>

<script setup>
import EmailAnalyticsGrid from "@/src/views/analytics/v2/marketing_campaign_analytics/email/EmailAnalyticsGrid.vue";
import EmailEngagementActivity from "@/src/views/analytics/v2/marketing_campaign_analytics/email/EmailEngagementActivity.vue";
import EmailFunnel from "@/src/views/analytics/v2/marketing_campaign_analytics/email/EmailFunnel.vue";
import { analyticTypes } from "@/src/constants/analyticConstants.js";
</script>
